<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <v-data-table :headers="headersTabela" :items="value" hide-actions
                      class="az-table-list tabela-itens"
                      no-data-text="Não há informação disponível">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.sequencia }}
                </td>
                <td ref="coluna_descricao">
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricaoCompleta"/>
                </td>
                <td>
                    <span>
                        {{ `${props.item.codigoElementoSubElemento} - ${props.item.descricaoElementoSubElemento}` }}
                    </span>
                </td>
                <td align="right">
                    {{ props.item.descricaoUnidadeMedida }}
                </td>
                <td align="right">
                    {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                </td>
                <td align="right">
                    {{ props.item.tipo }}
                </td>
            </template>
        </v-data-table>
    </v-flex>
</template>

<script>
import {situacoesItensELotes} from '@/core/constants'

export default {
    name: 'PainelItemLegado',
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        possuiValorReferencia: {
            type: Boolean,
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixOuSuffixValor:{
            type: String
        },
        criterioJulgamento:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            tamanho: null,
            situacoesItensELotes
        }
    },
    computed: {
        total() {
            let total = 0
            this.value.forEach(item => {
                if (item.totalEstimado > 0) {
                    total += item.totalEstimado
                }
            })
            return total
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        },
        headersTabela(){
            return [
                {
                    text: 'Seq',
                    sortable: true,
                    align: 'left',
                    width: '5%',
                    class: 'primary--text',
                    value: 'sequencia'
                },
                {
                    align: 'left',
                    text: 'Descrição',
                    value: 'descricao',
                    width: '30%',
                    class: 'primary--text',
                    sortable: false
                },
                {
                    text: 'Linha fornecimento',
                    sortable: false,
                    value: 'situacao',
                    align: 'left',
                    width: '10%',
                    class: 'primary--text'
                },
                {
                    text: 'Unidade',
                    value: 'unidade',
                    sortable: false,
                    align: 'right',
                    width: '8%',
                    class: 'primary--text'
                },
                {
                    text: 'Qtd',
                    value: 'quantidade',
                    sortable: false,
                    align: 'right',
                    width: '5%',
                    class: 'primary--text'
                },
                {
                    value: 'tipo',
                    text: 'Tipo',
                    align: 'right',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                }
            ]
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    },
    methods: {
        pegarTamanho() {
            this.tamanho = 0.082 * window.innerWidth
        }
    }
}
</script>

<style scoped lang="stylus">
.tabela-itens, .tabela-itens-manual
    padding 16px

@media (max-width 720px)
    .tabela-itens, .tabela-itens-manual
        padding 0

        td:nth-of-type(1):before
            content "Sequência:"

        td:nth-of-type(6)
            text-align left

        td:nth-of-type(7)
            text-align left

        td:nth-of-type(8)
            text-align left

    .tabela-itens
        td:nth-of-type(2):before
            content "Código:"

        td:nth-of-type(3):before
            content "Descrição:"

        td:nth-of-type(4):before
            content "Situação:"

        td:nth-of-type(5):before
            content "Exclusivo:"

        td:nth-of-type(6):before
            content "Unidade:"

        td:nth-of-type(7):before
            content "Quantidade:"

        td:nth-of-type(8):before
            content "Estimado Unitário (R$):"

        td:nth-of-type(9):before
            content "Estimado Total (R$):"

        td:nth-of-type(9)
            text-align left

    .tabela-itens-manual
        td:nth-of-type(2):before
            content "Descrição:"

        td:nth-of-type(3):before
            content "Situação:"

        td:nth-of-type(4):before
            content "Exclusivo:"

        td:nth-of-type(5):before
            content "Unidade:"

        td:nth-of-type(6):before
            content "Quantidade:"

        td:nth-of-type(7):before
            content "Estimado Unitário (R$):"

        td:nth-of-type(8):before
            content "Estimado Total (R$):"

        td:nth-of-type(5)
            text-align left
</style>
